import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import './CommentReportDialog.scss';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import i18n from '../../i18n';
import { withStyles } from '@material-ui/core/styles';
const styles = {
    icon: {
        padding: "8px 12px",
    }
}
class CommentReportDialog extends Component {
    renderLang = () => {
        const { lang } = this.props;
        if (lang === "ko") {
            return (
                <div className="comment-report-dialog-container-text">
                    허위 신고일 경우, 신고자의 서비스 활동이<br />
                    제한 될 수 있으니 신중하게 신고해주세요.
                </div>
            )
        }
        else if (lang === "jp") {
            return (
                <div className="comment-report-dialog-container-text">
                    偽りの通報をされた場合、通報者のサービス及び利用が<br />
                    制限される為、慎重に通報してください。
                </div>
            )
        }
        else {
            return (
                <div className="comment-report-dialog-container-text">
                    If you make false report, your account can be banned<br />
                    Please be aware to report the issue
                </div>
            )
        }
    }
    render() {
        const { lang, reportValue, onChange, open, onClose, sendReport, classes } = this.props
        return (
            <Dialog open={open} onClose={onClose}>
                <div className= "comment-report-dialog-container-web">
                <div className="comment-report-dialog-container" lang={lang}>
                    <div className="comment-report-dialog-container-titleWrap">
                        <div className="comment-report-dialog-container-title">{i18n.t("web.gallery.commnet.report")}</div>
                        {this.renderLang()}
                    </div>

                    <div className="comment-report-dialog-container-div">
                        <FormControl component="fieldset">
                            <div className="comment-report-dialog-container-subTitleWrap">
                                <div className="comment-report-dialog-container-subTitle">{i18n.t("web.gallery.reportReason")}</div>
                                <div className="comment-report-dialog-container-subTitleText" color={"#adadad"} fontSize={"12px"}>{i18n.t("web.gallery.reportSelect")}</div>
                            </div>
                            <RadioGroup aria-label="report" name="report" value={reportValue} onChange={onChange}>
                                <FormControlLabel value="a" control={<Radio classes={{ root: classes.icon }} />} label={i18n.t("web.gallery.comment.report.a")} />
                                <FormControlLabel value="b" control={<Radio classes={{ root: classes.icon }} />} label={i18n.t("web.gallery.comment.report.b")} />
                                <FormControlLabel value="c" control={<Radio classes={{ root: classes.icon }} />} label={i18n.t("web.gallery.comment.report.c")} />
                                <FormControlLabel value="d" control={<Radio classes={{ root: classes.icon }} />} label={i18n.t("web.gallery.comment.report.d")} />
                                <FormControlLabel value="e" control={<Radio classes={{ root: classes.icon }} />} label={i18n.t("web.gallery.comment.report.e")} />
                            </RadioGroup>
                        </FormControl>
                    </div>

                    <div className="comment-report-dialog-buttonWrap">
                        <button className="comment-report-dialog-container-button-cancel" onClick={onClose} style={{ margin: "0 5px 0 0" }} cancel>{i18n.t("global.cancel")}</button>
                        <button className="comment-report-dialog-container-button-confirm" onClick={sendReport} >{i18n.t("web.gallery.report")}</button>
                    </div>

                </div>
                </div>
               
            </Dialog>
        );
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(withStyles(styles)(CommentReportDialog))